import { ajaxErrorAlert, ajaxPost, parceAjaxErrorResponse } from "../utils";
import { csrfToken, ErrorSwal, SuccessSwal, SwalPost } from "../../app";
import { bsModal } from "../plugins";

$(function () {
  const body = $("body");

  if (body.hasClass("user-list")) {
    const table = $(".table");
    let form = $(".listFilterForm");

    table.DataTable({
      ajax: {
        type: "POST",
        data: function (d) {
          for (let v of Object.values(form.serializeArray())) {
            d[v.name] = v.value;
          }
        },
      },
    });

    $(document).on("click", ".rowActionMenuBtn", (e) => {
      const btn = $(e.currentTarget);
      const rowId = btn.closest("tr").attr("id");
      const menu = btn.parent().find(".rowActionMenu");

      ajaxPost(rowId + "/action-buttons/", {}, btn).then((response) => {
        menu.html(String(response["html"]));
      });
    });

    form.on("submit", (e) => {
      e.preventDefault();
      table.DataTable().ajax.reload();
      $(body).modal("hideAll");
    });
  }

  if (body.hasClass("user-create") || body.hasClass("user-update")) {
    $(".generateRandomPassword").on("click", function () {
      const password = Math.random().toString(36).slice(-8);
      $(this).closest("div").find("input").val(password);
    });

    $(".generateRandomApiKey").on("click", function () {
      const username = $('input[name="username"]').val();
      const environment = $("html").data("environment").slice(0, 4);
      const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let api_key = "";
      for (let i = 0; i < 32; i++) {
        api_key += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      $(this)
        .closest("div")
        .find("input")
        .val(`${username}-${environment}${api_key}`);
    });

    $("#userUpdateCreateForm").on("submit", (e) => {
      e.preventDefault();
      const form = $(e.target);

      ajaxPost("", form.serializeArray(), form)
        .then((response) => {
          SuccessSwal.fire({ timer: 1000 }).then(() => {
            window.location.href = String(response["redirect_url"]);
          });
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        });
    });
  }

  if (
    body.hasClass("user-detail") ||
    body.hasClass("user-update") ||
    body.hasClass("user-permissions") ||
    body.hasClass("user-delete") ||
    body.hasClass("user-logs")
  ) {
    $("#userEntryHistoryModal").on("click", (e) => {
      e.preventDefault();
      const url = $(e.currentTarget).attr("href");
      const modal = bsModal("full", {
        title: "Sistemə giriş tarixçəsi",
        modalId: "userEntryHistoryModal2",
        backdrop: "none",
      });

      ajaxPost(url, { action: "modal_content" })
        .then((response) => {
          $(modal).modal("content", response.html);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors).join("<br>"),
          }).then(() => {
            $(modal).modal("hide");
          });
        });
    });
  }

  if (body.hasClass("user-delete")) {
    $(".deleteUser").on("click", (e) => {
      e.preventDefault();
      const button = $(e.currentTarget);
      const url = button.attr("href");
      button.attr("disabled", "disabled");

      SwalPost(
        url,
        {},
        {
          text: "Silmək istədiyinizdən əminsinizmi?",
          icon: "warning",
        },
      )
        .then((response) => {
          SuccessSwal.fire({ timer: 1000 }).then(() => {
            window.location.href = String(response["redirect_url"]);
          });
        })
        .finally(() => {
          button.removeAttr("disabled");
        });
    });
  }

  if (
    body.hasClass("group-create") ||
    body.hasClass("group-update") ||
    body.hasClass("user-permissions")
  ) {
    $(document).on("submit", "#groupUpdateCreateForm", (e) => {
      e.preventDefault();
      const form = $(e.target);
      ajaxPost("", form.serializeArray(), form)
        .then((response) => {
          SuccessSwal.fire({ timer: 1000 }).then(() => {
            window.location.href = String(response["redirect_url"]);
          });
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        });
    });

    const calculatePermissionsCount = () => {
      const allPermissions = $("input[name=user_permissions]");
      const selectedPermissions = allPermissions.filter(":checked");
      const menuAll = $("[data-type=all]");
      const menuAppItems = $('li[data-type="app"]');
      const menuModelItems = $('li[data-type="model"]');

      menuAll
        .find("span.count")
        .text(
          " (" + allPermissions.length + "/" + selectedPermissions.length + ")",
        );
      menuAppItems.each(function (i, el) {
        const app = $(el).data("app");
        const appPermissions = allPermissions.filter("[data-app=" + app + "]");
        const appSelectedPermissions = selectedPermissions.filter(
          "[data-app=" + app + "]",
        );
        $(el)
          .find("span.count")
          .text(
            " (" +
              appPermissions.length +
              "/" +
              appSelectedPermissions.length +
              ")",
          );
      });
      menuModelItems.each(function (i, el) {
        const model = $(el).data("model");
        const modelPermissions = allPermissions.filter(
          "[data-model=" + model + "]",
        );
        const modelSelectedPermissions = selectedPermissions.filter(
          "[data-model=" + model + "]",
        );
        $(el)
          .find("span.count")
          .text(
            " (" +
              modelPermissions.length +
              "/" +
              modelSelectedPermissions.length +
              ")",
          );
      });
    };
    calculatePermissionsCount();

    $("input[name=user_permissions]").on("change", (e) => {
      calculatePermissionsCount();
    });

    $(".permission-groups .nav-link").on("click", (e) => {
      const target = $(e.currentTarget);
      const type = target.parent().data("type");
      const allPermissions = $("input[name=user_permissions]");
      if (type === "all") {
        $(".permission-groups .nav-link").removeClass("active");
        target.addClass("active");
        allPermissions.closest(".nav-item").show();
      } else if (type === "app") {
        const app = target.parent().data("app");
        allPermissions.closest(".nav-item").hide();
        allPermissions
          .filter("[data-app=" + app + "]")
          .closest(".nav-item")
          .show();
        $(".permission-groups .nav-link").removeClass("active");
        target.addClass("active");
      } else if (type === "model") {
        const model = target.parent().data("model");
        allPermissions.closest(".nav-item").hide();
        allPermissions
          .filter("[data-model=" + model + "]")
          .closest(".nav-item")
          .show();
        $(".permission-groups .nav-link").removeClass("active");
        target.addClass("active");
      }
    });

    $("#permissionSearch").on("keyup", (e) => {
      $("[data-type=all] .nav-link").trigger("click");

      const value = e.target.value.toLowerCase();

      const allPermissions = $("input[name=user_permissions]");
      allPermissions.closest(".nav-item").hide();

      allPermissions.each(function (i, el) {
        if (
          $(el).parent().find("label").text().toLowerCase().indexOf(value) > -1
        ) {
          $(el).closest(".nav-item").show();
        }
      });
    });
  }
});
